export const parseOptionalWholeNumber = (value, { max, label }) => {
  const raw = String(value ?? "").trim();
  if (!raw) return { value: null };
  if (!/^\d+$/.test(raw)) {
    return { error: `${label} must be a whole number.` };
  }
  const parsed = Number.parseInt(raw, 10);
  if (max != null && parsed > max) {
    return { error: `${label} must be ${max} or less.` };
  }
  return { value: parsed };
};

export const parseTournamentAverage = (average, { hasAverage = true } = {}) => {
  if (!hasAverage) {
    return { value: null, hasAverage: false };
  }
  const averageRaw = String(average ?? "").trim();
  const averageParsed = Number.parseInt(averageRaw, 10);
  if (
    !averageRaw ||
    !Number.isInteger(averageParsed) ||
    !/^\d+$/.test(averageRaw)
  ) {
    return { error: "Average is required." };
  }
  if (averageParsed < 0 || averageParsed > 300) {
    return { error: "Average must be between 0 and 300." };
  }
  return { value: averageParsed, hasAverage: true };
};

export const parseExtractedRowEdits = ({ name, average, games, pins }) => {
  const errors = {};
  const extractedName = String(name || "").trim();
  if (!extractedName) {
    errors.name = "Name is required.";
  }

  const averageRaw = String(average ?? "").trim();
  const averageParsed = Number.parseInt(averageRaw, 10);
  if (!averageRaw || !Number.isInteger(averageParsed) || !/^\d+$/.test(averageRaw)) {
    errors.average = "Average is required.";
  } else if (averageParsed < 0 || averageParsed > 300) {
    errors.average = "Average must be between 0 and 300.";
  }

  const gamesResult = parseOptionalWholeNumber(games, {
    max: 400,
    label: "Games",
  });
  if (gamesResult.error) errors.games = gamesResult.error;

  const pinsResult = parseOptionalWholeNumber(pins, {
    max: 200000,
    label: "Pins",
  });
  if (pinsResult.error) errors.pins = pinsResult.error;

  return {
    errors,
    values: {
      extractedName,
      average: errors.average ? null : averageParsed,
      games: gamesResult.value ?? null,
      pins: pinsResult.value ?? null,
    },
  };
};
